import { create } from 'zustand'

interface HelpContent {
  header: string
  body: React.ReactNode
  footer?: React.ReactNode
}

interface HelpPanelState {
  isOpen: boolean
  content: HelpContent | null
  setOpen: (open: boolean) => void
  setContent: (content: HelpContent | null) => void
  toggle: () => void
  reset: () => void
}

export const useHelpPanelStore = create<HelpPanelState>((set) => ({
  isOpen: false,
  content: null,
  setOpen: (open: boolean) => set({ isOpen: open }),
  setContent: (content: HelpContent | null) => set({ content }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  reset: () => set({ isOpen: false, content: null }),
}))
